import React, { useState } from 'react';
import { X } from 'lucide-react';

const BugReportModal = ({ show, onClose }) => {
  const [bugDescription, setBugDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show) return null;

  // Google Form URL and field name extracted from the provided HTML
  const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeb5VNMXiDaeaAPxnAlK-6p-WrrhnEF4nA_L6w4wkwicdRSEw/formResponse';
  const FIELD_NAME = 'entry.1468701282';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Create form data for Google Forms submission
      const formData = new FormData();
      formData.append(FIELD_NAME, bugDescription);

      // Submit to Google Forms
      await fetch(GOOGLE_FORM_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors' // Required for Google Forms cross-origin requests
      });

      // Reset form and close modal
      setBugDescription('');
      onClose();
      
      // Show success message
      alert('Bug report submitted successfully! Thank you for your feedback.');
    } catch (error) {
      console.error('Error submitting bug report:', error);
      alert('Error submitting bug report. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <h2>Report a Bug</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="bugDescription">Bug Description</label>
            <textarea
              id="bugDescription"
              value={bugDescription}
              onChange={(e) => setBugDescription(e.target.value)}
              placeholder="Describe the bug..."
              rows={3}
              required
              style={{ width: '100%', minHeight: '80px' }}
            />
          </div>

          <div className="modal-buttons">
            <button
              type="submit"
              className="btn btn-confirm"
              disabled={isSubmitting || !bugDescription.trim()}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Bug'}
            </button>
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onClose}
              disabled={isSubmitting}
            >
              <X size={16} />
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BugReportModal;